import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Button } from "reactstrap";
import QuestionType from "./QuestionType";
import Input from "reactstrap/lib/Input";
import FormGroup from "reactstrap/lib/FormGroup";
import { FaCheck } from 'react-icons/fa';
import Accordion from "../Accordion";
import { geti, DynamicMappingDataQuery } from "@agenturid/u20tools";
import { expandConditionForCurrentQuestion, generateRandomObjectId } from "../../helper/helper";

class QuestionRepeated extends QuestionType {
  constructor(props) {
    super(props);
    this.state = {
      accordionTabs: {},
      elements: []
    };
  }

  getTextValue() {
    let txt = this.getValue();
    if (txt == null && this.hasVorauswahl()) {
      txt = this.getVorauswahl();
      this.setValue(txt);
    }
    return txt;
  }

  buildQuestionForBasicQuestion(repeatedQuestion, repeatedElement, value, q, i, list, additionalData) {

    const metaInfo = {};
    let id = this.question().id+"_"+q.id;
    let replaceIdentifier = this.question().id+"_{{id}}";
    if (value && value.id) {
      id = this.question().id+"_"+value.id+"_"+q.id+"_"+repeatedQuestion.id;
      replaceIdentifier = this.question().id+"_"+value.id+"_{{id}}_"+repeatedQuestion.id;
    }
    else if (value && value._id) {
      id = this.question().id+"_"+value._id+"_"+q.id+"_"+repeatedQuestion.id;
      replaceIdentifier = this.question().id+"_"+value._id+"_{{id}}_"+repeatedQuestion.id;
    }

    let v = value;
    if (q.type !== "parameter") {
      if (q.targetField) {
        v = geti(value, q.targetField.id);
      }
    }

    if (q.type === "parameter") {
      if (q.parameterObject) {
        const pobject = geti(v, q.parameterObject.id);
        if (pobject) {
          if (pobject.parameters) {
            metaInfo.parameters = pobject.parameters;
          }
        }
      }
    }

    if (q.type === "condition") {
      const qclist = [];

      for (const qc of q.questions) {
        const condition = expandConditionForCurrentQuestion(q.condition, replaceIdentifier, q , list);
        const qcq = this.buildQuestionForBasicQuestion(repeatedQuestion, repeatedElement, value,
          qc, i, list, {
            condition: condition,
            Bedingung: condition
          });
        if (Array.isArray(qcq)) {
          for (const e of qcq) {
            qclist.push(e);
          }
        }
        else {
          qclist.push(qcq);
        }
      }

      return qclist;
    }

    const question = Object.assign({}, q, {
      id: id,
      parentQuestion: repeatedQuestion,
      parentElement: value,
      metaInfo: metaInfo
    }, additionalData);

    return {
      question: Object.assign({}, q, {
        commentChildQuestionId: q.id,
        dynamicTargetField: this.generateTargetField(repeatedQuestion, repeatedElement, value, q),
        parentQuestion: repeatedQuestion,
        parentElement: value,
        question: question,
        value: v,
        Text: q.text,
        Datentyp: q.type,
        id: id,
        Category: this.question().Category,
        Subcategory: this.question().Subcategory
      }, additionalData),
      answer: {
        id: id,
        question: question,
        value: v
      }
    };
  }


  buildQuestionForBasicQuestions(value, list, repeatedQuestion, repeatedElement) {
    const d = {
      questions: [],
      answers: []
    };
    list.map((q, index) => {
        const f = this.buildQuestionForBasicQuestion(repeatedQuestion, repeatedElement, value, q, index, list);
        if (Array.isArray(f)) {
          for (const e of f) {
            d.questions.push(e.question);
            d.answers.push(e.answer);
          }
        }
        else {
          d.questions.push(f.question);
          d.answers.push(f.answer);
        }

    });

    return d;
  }

  // When you clear "repeatedQuestion" or "repeatedElement" it is saved as an empty array and
  // not removed. An empty array is truthy, so the if() takes the wrong branch, looks for a
  // question with the id "undefined" and the accordion stays empty without any error.
  normalizeRepeatedConfig(config) {
    let c = config;
    if (Array.isArray(c)) {
      c = c.find((entry) => entry && entry.id);
    }
    return (c && c.id) ? c : null;
  }

  // Vorfilter der Wiederholung. Er schraenkt ausschliesslich die angezeigten Reiter ein -
  // das Quellfeld (z.B. website.headerNavigation) bleibt unberuehrt, damit die Navigation
  // vollstaendig bleibt. Leere Gruppen gelten als "kein Filter", sonst wuerde eine
  // angelegte, aber nie gefuellte Bedingung alle Reiter verschlucken.
  getRepeatFilter() {
    const f = this.question().repeatedFilter;
    if (!f || typeof f !== "object") {
      return null;
    }
    const jsonQuery = f.jsonQuery ? f.jsonQuery : f;
    if (!jsonQuery || !Array.isArray(jsonQuery.children1) || jsonQuery.children1.length === 0) {
      return null;
    }
    return { jsonQuery: jsonQuery };
  }

  /**
   * Unter welchem Pfad das einzelne Element in der Website-Kopie haengen kann.
   *
   * Es gibt zwei legitime Schreibweisen fuer dieselbe Sache: das Website-Feld
   * ("headerNavigation", so steht es in der Feldauswahl bei "Wiederhole dieses Element")
   * und der Auswahlpfad der Quellfrage ("master.headerNavigation", so steht es im
   * Query-Builder bei "Wiederhole diese Frage"). Welche davon im Filter benutzt wird,
   * darf keine Rolle spielen - sonst trifft die Regel still nichts.
   */
  getRepeatFilterCandidates(repeatedQuestion, repeatedElement) {
    const list = [];
    const push = (v) => {
      if (v && list.indexOf(v) < 0) {
        list.push(v);
      }
    };
    // Zu jedem Pfad auch die andere Schreibweise aufnehmen, damit es nicht davon abhaengt,
    // aus welcher Auswahl der Redakteur das Feld gegriffen hat.
    const add = (p) => {
      const v = p ? String(p).replace(/\[\]/g, "") : "";
      if (!v) {
        return;
      }
      push(v);
      if (v.indexOf("master.") === 0) {
        push(v.slice("master.".length));
      }
      else if (v.indexOf("global.") === 0) {
        push(v.slice("global.".length));
      }
      else {
        push("master." + v);
      }
    };
    if (repeatedElement) {
      add(repeatedElement.id);
    }
    if (repeatedQuestion && repeatedQuestion.id) {
      const q = this.qCtrl().getQuestionById(repeatedQuestion.id);
      const ddm = (q && Array.isArray(q.dynamicDataMapping)) ? q.dynamicDataMapping[0] : null;
      if (ddm && ddm.query && ddm.query.select) {
        add(ddm.query.select.id);
      }
      if (q && q.targetField) {
        add(q.targetField.id);
      }
    }
    return list;
  }

  // Alle Feldbezuege einer Bedingung: der Regel-Feldname und, bei Feld-gegen-Feld-Regeln,
  // auch die rechte Seite.
  collectFilterFieldRefs(node, out = []) {
    if (!node || typeof node !== "object") {
      return out;
    }
    if (node.properties) {
      if (typeof node.properties.field === "string") {
        out.push(node.properties.field);
      }
      const srcs = Array.isArray(node.properties.valueSrc) ? node.properties.valueSrc : [];
      const vals = Array.isArray(node.properties.value) ? node.properties.value : [];
      for (let i = 0; i < vals.length; i++) {
        if (srcs[i] === "field" && typeof vals[i] === "string") {
          out.push(vals[i]);
        }
      }
    }
    if (Array.isArray(node.children1)) {
      for (const c of node.children1) {
        this.collectFilterFieldRefs(c, out);
      }
    }
    return out;
  }

  // Welche der moeglichen Einhaengungen benutzen die Regeln tatsaechlich? Die gewinnt,
  // damit so wenig wie moeglich umgeschrieben werden muss. Nennt keine Regel eine davon,
  // bleibt der Pfad des aktiven Zweigs.
  pickFilterPath(candidates, fieldRefs, fallback) {
    for (const c of candidates) {
      for (const f of fieldRefs) {
        const ref = String(f).replace(/\[\]/g, "");
        if (ref === c || ref.indexOf(c + ".") === 0) {
          return c;
        }
      }
    }
    return fallback;
  }

  /**
   * Schreibt die Regelfelder auf die gewaehlte Einhaengung um - auf einer Kopie, die
   * Konfiguration bleibt unberuehrt.
   *
   * Bewusst NICHT beide Einhaengungen nacheinander pruefen und die Ergebnisse vereinigen:
   * unter der jeweils falschen Einhaengung ist das Feld undefined, eine Regel mit
   * Verneinung ("name ist nicht Home") trifft dort also immer zu - die Vereinigung
   * liesse dann alles durch. Ein umgeschriebenes Feld ist eindeutig.
   */
  rewriteFilterFields(node, otherPaths, targetPath) {
    if (!node || typeof node !== "object") {
      return node;
    }
    const mapRef = (ref) => {
      if (typeof ref !== "string") {
        return ref;
      }
      const bare = ref.replace(/\[\]/g, "");
      for (const p of otherPaths) {
        if (bare === p) {
          return targetPath;
        }
        if (bare.indexOf(p + ".") === 0) {
          return targetPath + bare.slice(p.length);
        }
      }
      return ref;
    };
    const copy = Object.assign({}, node);
    if (node.properties) {
      const props = Object.assign({}, node.properties);
      if (typeof props.field === "string") {
        props.field = mapRef(props.field);
      }
      const srcs = Array.isArray(props.valueSrc) ? props.valueSrc : [];
      if (Array.isArray(props.value)) {
        props.value = props.value.map((v, i) => (srcs[i] === "field" ? mapRef(v) : v));
      }
      copy.properties = props;
    }
    if (Array.isArray(node.children1)) {
      copy.children1 = node.children1.map((c) => this.rewriteFilterFields(c, otherPaths, targetPath));
    }
    return copy;
  }

  /**
   * Loest den Elternknoten eines Elements gegen dieselbe Liste auf - nur fuer den Filter.
   *
   * WARUM: "parentItem" ist eine reine Referenz ({_id, ref, kind}) und traegt keinen Namen.
   * Ohne Aufloesung liesse sich "nur die Kinder von Leistungen" ausschliesslich als
   * Id-Vergleich schreiben. Nicht zu verwechseln mit "parentElement", das filterList aus
   * root.element setzt - das ist das uebergeordnete Formular-Element, im Webconfig meist
   * gar nicht vorhanden.
   *
   * Es werden nur flache Kennfelder uebernommen, damit der Filterkontext nicht den halben
   * Navigationsbaum mitzieht. Gesetzt wird ausschliesslich auf der Kopie.
   */
  resolveParentForFilter(element, list) {
    const ref = element ? element.parentItem : null;
    if (!ref || typeof ref !== "object") {
      return null;
    }
    const parentId = ref._id || ref.ref || ref.id;
    if (!parentId) {
      return null;
    }
    for (const candidate of list) {
      if (!candidate || typeof candidate !== "object" || candidate === element) {
        continue;
      }
      const id = candidate._id || candidate.id || candidate.ref;
      if (id && String(id) === String(parentId)) {
        const out = Object.assign({}, ref);
        for (const k of ["name", "title", "url", "default_url", "kind", "permalink"]) {
          if (typeof candidate[k] !== "undefined") {
            out[k] = candidate[k];
          }
        }
        return out;
      }
    }
    return null;
  }

  /**
   * Filtert die Reiter-Liste, ohne die Originale anzufassen.
   *
   * filterList setzt an jedem Element "element" und "parentElement" und haengt es in eine
   * Kopie der Website. Laeuft das direkt auf den echten Navigationseintraegen, landen diese
   * Zusatzfelder im gespeicherten Website-Dokument. Deshalb werden Kopien gefiltert und das
   * Ergebnis per Index auf die Originale zurueckgemappt.
   */
  applyRepeatFilter(list, repeatedQuestion, repeatedElement) {
    const filter = this.getRepeatFilter();
    if (!filter || !Array.isArray(list) || list.length === 0) {
      return list;
    }
    try {
      // Der erste Kandidat ist der Pfad des aktiven Zweigs und dient als Rueckfall,
      // wenn keine Regel eine der Schreibweisen nennt.
      const candidates = this.getRepeatFilterCandidates(repeatedQuestion, repeatedElement);
      const fieldRefs = this.collectFilterFieldRefs(filter.jsonQuery);
      const parentPath = this.pickFilterPath(candidates, fieldRefs, candidates[0]);
      if (!parentPath) {
        return list;
      }
      const others = candidates.filter((c) => c !== parentPath);
      const jsonQuery = others.length > 0
        ? this.rewriteFilterFields(filter.jsonQuery, others, parentPath)
        : filter.jsonQuery;

      const marked = [];
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        if (e && typeof e === "object") {
          const copy = Object.assign({}, e, { __repeatIndex: i });
          const parent = this.resolveParentForFilter(e, list);
          if (parent) {
            copy.parentItem = parent;
          }
          marked.push(copy);
        }
      }
      const passed = new DynamicMappingDataQuery(this.qCtrl().getWebsite())
        .filterList(marked, { jsonQuery: jsonQuery }, parentPath);
      const keep = {};
      for (const p of (passed || [])) {
        if (p && typeof p.__repeatIndex !== "undefined") {
          keep[p.__repeatIndex] = true;
        }
      }
      return list.filter((e, i) => keep[i] === true);
    }
    catch (e) {
      console.error("Vorfilter der Wiederholung konnte nicht ausgewertet werden", e);
      return list;
    }
  }

  buildAccordionTabs() {
    const repeatedQuestion = this.normalizeRepeatedConfig(this.question().repeatedQuestion);
    const repeatedElement = this.normalizeRepeatedConfig(this.question().repeatedElement);

    // Remember what we built from so we do not loop over our own setState
    this.lastBuiltSignature = this.getSourceSignature();

    if (repeatedQuestion) {
      const q = this.qCtrl().getQuestionById(repeatedQuestion.id);
      const v = this.qCtrl().getValueForQuestion(q);
      let vWithLabels = this.qCtrl().getOptionByName(q, v);

      if (vWithLabels) {
        if (!Array.isArray(vWithLabels)) {
          vWithLabels = [vWithLabels];
        }
        vWithLabels = this.applyRepeatFilter(vWithLabels, repeatedQuestion, null);
        const answers = [];
        const accordionTabs = {};
        vWithLabels.map((d) => {
          if (d && d.id && d.text) {
            d = Object.assign({}, d, {
                "name": d.text,
                _id: d.id
              });
          }
          if (d && d.name) {
            const questionAndAnswers = this.buildQuestionForBasicQuestions(d,
              this.question().questions, q, null);

            accordionTabs[d.name] = {
              name: d.name,
              element: d,
              parentQuestion: this.question(),
              questions: questionAndAnswers.questions
            };
            answers.push(...questionAndAnswers.answers);
          }
        });

        this.qCtrl().resetMultipleAnswers(answers);

        this.setState({elements: vWithLabels, accordionTabs: accordionTabs});

      }
    }
    else if (repeatedElement) {
      let v = this.qCtrl().getValueForField(repeatedElement);
      //const vWithLabels = this.qCtrl().getOptionByName(q, v);
      const q = {
        id: this.question().id
      };

      if (v) {

        if(!Array.isArray(v)) {
          v = [v];
        }
        v = v.map((e) => {
                      if (typeof e === "string") {
                        return {
                          _id: e
                        };
                      }
                      return e;
                    });
        v = this.applyRepeatFilter(v, null, repeatedElement);
        const answers = [];
        const accordionTabs = {};
        v.map((d) => {
          if (d && d._id) {
            const questionAndAnswers = this.buildQuestionForBasicQuestions(d,
              this.question().questions, q, repeatedElement);

            accordionTabs[d._id] = {
              name: d.name ? d.name : d.text ? d.text : d._id,
              element: d,
              parentQuestion: this.question(),
              questions: questionAndAnswers.questions,
              creatable: this.question().creatable
            };
            answers.push(...questionAndAnswers.answers);
          }
        });

        this.qCtrl().resetMultipleAnswers(answers);

        this.setState({elements: v, accordionTabs: accordionTabs});

      }
    }

  }

  onAnyValueChanged() {
    this.buildAccordionTabs();
  }

  // Comes from QuestionType.componentDidUpdate when lastFieldChanged moved. Without this the
  // accordion only refreshed when the user clicked something - no option for a hidden question.
  updateFields() {
    this.buildAccordionTabs();
  }

  // Fingerprint of the data the tabs are built from - either the value of the repeated
  // question or the field behind repeatedElement
  getSourceSignature() {
    const repeatedQuestion = this.normalizeRepeatedConfig(this.question().repeatedQuestion);
    const repeatedElement = this.normalizeRepeatedConfig(this.question().repeatedElement);

    let source = null;
    if (repeatedQuestion) {
      source = this.qCtrl().getValueForQuestion(this.qCtrl().getQuestionById(repeatedQuestion.id));
    }
    else if (repeatedElement) {
      source = this.qCtrl().getValueForField(repeatedElement);
    }

    if (!Array.isArray(source)) {
      return source ? String(source) : "";
    }

    return source.map((e) => {
      if (typeof e === "string") {
        return e;
      }
      if (!e) {
        return "";
      }
      const id = e._id || e.id || "";
      return (typeof e.checked === "undefined") ? id : id + ":" + e.checked;
    }).join(",");
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    super.componentDidUpdate(prevProps, prevState, snapshot);

    // The source can change without anybody telling us - the preselection writes over the
    // controller and posts no change message. So we just rebuild when it does not match.
    if (this.getSourceSignature() !== this.lastBuiltSignature) {
      this.buildAccordionTabs();
    }
  }

  componentDidMount() {
    this.registerForValueChanges();
    this.buildAccordionTabs();
  }

  componentWillUnmount() {
    this.unregisterForValueChanges();
  }

  onChildValueChanged() {
    this.buildAccordionTabs();
  }

  onDelete(e, index) {
    const v = this.qCtrl().getValueForField(
      this.normalizeRepeatedConfig(this.question().repeatedElement));
    if (!Array.isArray(v)) {
      return;
    }
    // Mit Vorfilter zeigt der Reiter-Index nicht mehr auf dieselbe Stelle im Quell-Array -
    // ein Loeschen ueber den Index wuerde den falschen Eintrag treffen. Deshalb primaer
    // ueber die Id des Elements, der Index bleibt nur Rueckfall ohne Filter.
    const element = (e && e.element) ? e.element : null;
    const id = element ? (element._id || element.id) : null;
    let target = -1;
    if (id) {
      target = v.findIndex((d) => d &&
        String(d._id || d.id || d.ref || "") === String(id));
    }
    if (target < 0 && !this.getRepeatFilter()) {
      target = index;
    }
    if (target > -1 && target < v.length) {
      v.splice(target, 1);
    }

    this.qCtrl().setValueForQuestion(this.question(), v, v);
    setTimeout(() => this.buildAccordionTabs(), 300);
  }

  createNewEntry() {
    let v = this.qCtrl().getValueForField(
      this.normalizeRepeatedConfig(this.question().repeatedElement));
    if (!v) {
      v = [];
    }
    const newElement = {
      _id: generateRandomObjectId()
    };
    v.push(newElement);
    this.qCtrl().setValueForQuestion(this.question(), v, v);
    setTimeout(() => this.buildAccordionTabs(), 300);
  }

  render() {
    const accordionTabs = this.state.accordionTabs;
    return <Container fluid={true} className={"text-container "+(this.hasError() ? "error" : "")}>
              <Row>
                <Col className={"p-1"} md={12}>

                  <Accordion onDelete={(e, index) => this.onDelete(e, index)} accordionTabs={accordionTabs} {...this.props}></Accordion>

                  {this.question().creatable == true && <div><Button onClick={(e) => this.createNewEntry(e)} >Neuer Eintrag</Button></div>}

                  {this.renderErrors()}
                </Col>
              </Row>
            </Container>;
  }


  /**
   * Zielpfad einer Kindfrage: Elternfeld + Id des Eintrags + eigenes Feld.
   *
   * Zwei Dinge sind hier entscheidend, beide gegen das echte Deep-Schema gemessen:
   *
   * 1. Das Elternfeld darf die Listenklammern NICHT mittragen. "jobs[].[<id>].name"
   *    laesst seti() mit "nested.find is not a function" auffliegen und laesst
   *    website.jobs als {} zurueck - die Liste ist dann weg, die Vorschau leer und das
   *    Akkordion ohne Quelle. Der Aufruf steckt in einem leeren catch, man sieht nichts.
   *    "jobs.[<id>].name" trifft genau den einen Eintrag.
   *
   * 2. value.element gibt es nur, wenn die Optionen vorher durch filterList gelaufen
   *    sind (das setzt es als Nebenwirkung). Wird das Akkordion gezeigt, ohne dass die
   *    Quellfrage gerendert wurde, fehlt es - dann gab es gar keinen Zielpfad, und der
   *    Wert landete im gleichnamigen Feld der Website. Deshalb auf _id/id zurueckfallen.
   */
  elementIdForTargetField(value) {
    if (!value) {
      return "";
    }
    if (value.element && value.element._id) {
      return value.element._id;
    }
    return value._id ? value._id : (value.id ? value.id : "");
  }

  generateTargetField(repeatedQuestion, repeatedElement, value, q) {
    let compinedField = null;
    const parentField = (raw) => String(raw).replace(/\[\]/g, "");

    if (repeatedQuestion && repeatedQuestion.targetField && q.targetField && value) {
      const elementId = this.elementIdForTargetField(value);
      if (elementId) {
        compinedField = parentField(repeatedQuestion.targetField.id) +
          ".[" + elementId + "]." + q.targetField.id;
      }
    }
    if (repeatedElement && repeatedElement.id && q.targetField && value) {
      compinedField = parentField(repeatedElement.id) +
        ".[" + this.elementIdForTargetField(value) + "]." + q.targetField.id;
    }

    return compinedField;
  }

}

QuestionRepeated.propTypes = {

};


export default QuestionRepeated;
